import React, { useCallback, useMemo, useState } from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import ApiService from '@common/services/ApiService';
import { DefaultModal } from '@common/components/default-modal';
import { DefaultButton } from '@common/components/default-button';
import { withStyles } from 'tss-react/mui';
import { unitResponsesStyles } from './styles';
import { vcmComponentStatusOptions } from './options';

const api = new ApiService();
const VcmApproveModal = ({
  classes,
  isOpened,
  onClose,
  onRefresh,
  unitResponses,
  vcmProfessionalQualifications,
  vcm
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const unapprovedCodes = useMemo(
    () => {
      const unapprovedUnits = unitResponses
        .filter(
          (unitResponse) =>
            unitResponse.status !== vcmComponentStatusOptions.approved.id
        )
        .map((unitResponse) => unitResponse.unit.code);

      const unapprovedQualifications = vcmProfessionalQualifications
        .filter(
          (vcmProfessionalQualification) =>
            vcmProfessionalQualification.status !==
            vcmComponentStatusOptions.approved.id
        )
        .map((vcmProfessionalQualification) => vcmProfessionalQualification.professional_qualification.code);

      return [...unapprovedUnits, ...unapprovedQualifications];
    },
    [unitResponses, vcmProfessionalQualifications]
  );

  const canApproveVcm = unapprovedCodes.length === 0;

  const handleSubmit = useCallback(async () => {
    setIsLoading(true);

    try {
      const url = `/api/v1/vcms/${vcm.id}/approve`;
      const res = await api.put(url);

      if (res.status === 200) {
        handleClose();
        onRefresh();
      } else if (res.status === 422 || res.status === 400) {
        setErrorMessage(res.json.message);
      } else {
        console.error('Unknown response', res);
      }
    } catch (error) {
      setErrorMessage(error.message);
    } finally {
      setIsLoading(false);
    }
  }, []);

  const handleClose = useCallback(() => {
    setErrorMessage(null);
    onClose();
  }, [setErrorMessage, onClose]);

  return (
    <DefaultModal
      isOpened={isOpened}
      isLoading={isLoading}
      onClose={handleClose}
      title="Approve VCM"
      action={
        canApproveVcm ? (
          <DefaultButton
            className={classes.button}
            onClick={handleSubmit}
            color="secondary"
            size="small"
            variant="contained"
          >
            Approve
          </DefaultButton>
        ) : (
          <DefaultButton
            className={classes.button}
            onClick={handleClose}
            size="small"
            variant="contained"
          >
            Close
          </DefaultButton>
        )
      }
    >
      <Grid container spacing={2}>
        <Grid size={12}>
          <Typography color="error" style={{ whiteSpace: 'pre-line' }}>{errorMessage}</Typography>
        </Grid>
        <Grid size={12} mb={4}>
          <Typography>
            {canApproveVcm
              ? 'This will notify the Educator and close off this revision of the VCM as approved.'
              : `You must approve all professional qualifications and units first. Unapproved codes: ${unapprovedCodes.join(', ')}`}
          </Typography>
        </Grid>
      </Grid>
    </DefaultModal>
  );
};

export default withStyles(VcmApproveModal, unitResponsesStyles, {
  withTheme: true
});
